<template>
  <button
    @click="props.onClick"
    class="w-fit inline-flex items-center px-2 pr-4 py-1.5 text-xs font-medium rounded-full transition-colors border-[1px]"
    :class="[
      props.isActive
        ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
        : 'bg-white text-gray-700 hover:bg-gray-200'
    ]"
  >
    <Dot class="w-4 h-4" />
    {{ props.title }}
  </button>
</template>

<script setup lang="ts">
import { Dot } from 'lucide-vue-next'

const props = defineProps<{
  title: string
  isActive: boolean
  onClick: () => void
}>()
</script>
